module.exports = __webpack_public_path__ + "static/img/a016.36490ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a016.jpg
// module id = iNiD
// module chunks = 0